import "./styles.css";

const categories = [
  ["Aves", "Rações para aves inicial até postura"],
  ["Ovinos e Caprinos", "Para crescimento e finalização"],
  ["Equinos", "Rações para equinos com 14% de proteínas"],
  ["Bovinos", "Rações para bezerros, gado de corte, vaca de leite e suplementos proteicos."],
];

const productLines = ["Aves", "Concentrados", "Equinos", "Ovinos e Caprinos", "Suínos", "Bovinos"];
const catalogWhatsapp = "https://wa.me/+5565992267181?text=Gostaria%20de%20receber%20o%20cat%C3%A1logo%20completo%20de%20ra%C3%A7%C3%B5es";

const catalogItems = [
  ["Aves", "Rações para todas as fases, incluindo postura e codornas.", "/assets/galinhas.jpg", "/produtos/#aves"],
  ["Concentrados", "Concentrados para aves e suínos, essenciais para crescimento e postura.", "/assets/wp-original/farelo-concentrado-scaled.jpg", "/produtos/#concentrados"],
  ["Equinos", "Ração equilibrada com 14% de proteína, em embalagem prática.", "/assets/cavalos.jpg", "/produtos/#equinos"],
  ["Ovinos e Caprinos", "Ração especial para ovinos e caprinos, disponível em embalagens de 30kg.", "/assets/carneiros.jpg", "/produtos/#ovinos"],
  ["Suínos", "Rações para crescimento e terminação de suínos.", "/assets/suinos.webp", "/produtos/#suinos"],
  ["Bovinos", "Suplementos proteicos, energéticos e farelão misturado para diferentes necessidades.", "/assets/bovinos.jpg", "/produtos/#bovinos"],
];

const posts = [
  {
    title: "Nutrição Vip: Um Evento Imperdível na Nobres Agroveterinária",
    date: "11, abril - 2024",
    image: "/assets/post-evento.png",
    href: "/nutricao-vip-um-evento-imperdivel-na-nobres-agroveterinaria/",
    body: [
      "No próximo dia 13 de abril, a Nobres Agroveterinária convida todos os amantes de animais para o evento Nutrição Vip.",
      "O encontro será realizado na loja localizada na Avenida Getúlio Vargas, 2101 - Nobres/MT, criando uma oportunidade para conhecer de perto os produtos da Nobres Rações.",
      "Durante o evento, participantes poderão interagir com especialistas em nutrição animal, tirar dúvidas e conhecer soluções para melhorar o cuidado diário com seus animais.",
    ],
  },
  {
    title: "Ração para bovinos: entenda sobre os insumos e composição",
    date: "16, fevereiro - 2024",
    image: "/assets/post-bovino.jpg",
    href: "/racao-para-bovinos-entenda-sobre-os-insumos-e-composicao/",
    body: [
      "No manejo alimentar, a ração para bovinos precisa ser de qualidade e ter composição balanceada para garantir saúde animal.",
      "Os cuidados com a alimentação do rebanho estão diretamente relacionados com produtividade, desempenho diário e melhor aproveitamento nutricional.",
      "Conhecer os insumos e a composição da dieta é essencial para produtores que buscam eficiência, segurança e regularidade nos resultados.",
    ],
  },
  {
    title: "Melhore a Performance do Seu Rebanho com a Ração para Gado de Corte 18% Proteína",
    date: "16, fevereiro - 2024",
    image: "/assets/post-rebanho.jpg",
    href: "/melhore-a-performance-do-seu-rebanho-com-a-racao-para-gado-de-corte-18-proteina/",
    body: [
      "A alimentação adequada do gado de corte é essencial para garantir saúde, bem-estar e produtividade dos animais.",
      "A ração para gado de corte com 18% de proteína oferece solução balanceada para atender às necessidades nutricionais do rebanho.",
      "Com orientação correta de uso e administração, o produto se destaca como opção confiável para criadores que buscam maximizar desempenho.",
    ],
  },
];

function submitByEmail(event: { preventDefault(): void; currentTarget: HTMLFormElement }, subject: string) {
  event.preventDefault();
  const data = new FormData(event.currentTarget);
  const body = Array.from(data.entries())
    .filter(([, value]) => String(value).trim())
    .map(([key, value]) => `${key}: ${String(value).trim()}`)
    .join("\n");
  window.location.href = `mailto:nobresracoes@grupogns.com.br?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

function Header() {
  return (
    <header className="siteHeader">
      <div className="topLine">
        <span>nobresracoes@grupogns.com.br</span>
        <span>(65) 99226-7181</span>
        <span>f</span>
        <span>◎</span>
      </div>
      <div className="navBar">
        <a className="brand" href="/"><img src="/assets/logo-nobres.png" alt="Nobres Rações" /></a>
        <nav>
          <a href="/quem-somos/">Quem Somos</a>
          <a href="/produtos/">Rações</a>
          <a href="/compromissos/">Compromissos</a>
          <a href="/sustentabilidade/">Sustentabilidade</a>
          <a href="/noticias/">Notícias</a>
          <a href="/contato/">Contato</a>
          <a className="budget" href="/contato/">Orçamento</a>
        </nav>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer>
      <div className="footerInner">
        <div>
          <p>Nobres Rações, onde a dedicação à nutrição animal é a força motriz por trás de nossa história.</p>
          <div className="socials"><span>f</span><span>◎</span></div>
        </div>
        <div>
          <h3>Rações</h3>
          {productLines.map((line) => <a href="/produtos/" key={line}>{line}</a>)}
        </div>
        <div>
          <h3>A empresa</h3>
          <a href="/quem-somos/">Quem Somos</a>
          <a href="/compromissos/">Compromissos</a>
          <a href="/sustentabilidade/">Sustentabilidade</a>
          <a href="/noticias/">Notícias</a>
          <a href="/contato/">Contatos</a>
        </div>
        <div>
          <h3>Novidades</h3>
          <p>Assine nossa newsletter e receba novidades sobre nossos produtos e promoções especiais.</p>
          <form className="newsletterForm" onSubmit={(event) => submitByEmail(event, "Newsletter Nobres Racoes")}>
            <input name="email" type="email" placeholder="E-mail" required />
            <button type="submit">Assine já</button>
          </form>
        </div>
      </div>
      <div className="copyright">
        <span>Copyright © 2023 Nobres Rações, Todos Direitos Reservados.</span>
        <span>✓ Site desenvolvido por Spatium Marketing | Termos | Privacidade | Cookies</span>
      </div>
    </footer>
  );
}

function PageHero({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <section className="pageHero">
      <h1>{title}</h1>
      {subtitle ? <h4>{subtitle}</h4> : null}
    </section>
  );
}

function ProductsPage() {
  return (
    <main>
      <Header />
      <PageHero title="Rações" />
      <section className="internalPage productsPage">
        <h2>NOSSOS PRODUTOS</h2>
        <p>Temos rações para diversos tipos de criações.</p>
        <div className="categoryCards internalCards">
          {categories.concat([["Concentrados", "Concentrados para aves e suínos, essenciais para crescimento e postura."]]).map(([title, text]) => (
            <article key={title}>
              <span>♘</span>
              <h2>{title}</h2>
              <p>{text}</p>
            </article>
          ))}
        </div>
        <div className="productSections">
          {catalogItems.map(([line, text, image, href]) => (
            <article id={href.split("#")[1]} key={line}>
              <img src={image} alt={line} />
              <div>
                <h2>Rações - {line === "Equinos" ? "Equínos" : line}</h2>
                <p>{text}</p>
                <ul>
                  <li>Formulação voltada para o manejo diário.</li>
                  <li>Atendimento para cotação e orientação de linha.</li>
                  <li>Entrega conforme disponibilidade regional.</li>
                </ul>
                <a className="button" href="/contato/">Solicitar orçamento</a>
              </div>
            </article>
          ))}
        </div>
      </section>
      <CtaBand />
      <Footer />
    </main>
  );
}

function AboutPage() {
  return (
    <main>
      <Header />
      <PageHero title="Quem Somos" />
      <section className="internalPage aboutPage">
        <div>
          <h4>Bem-vindo a Nobres Rações</h4>
          <h2>Nobres Rações</h2>
          <p>Nutrição animal com qualidade e compromisso desde 2018. Paixão pelos animais, excelência garantida.</p>
          <p>As atividades da Nobres Rações tiveram início em abril de 2018, marcando o começo de uma jornada pautada pela paixão pelos animais e pelo compromisso com a satisfação dos clientes.</p>
          <p>A marca nasceu para oferecer não apenas produtos, mas soluções que contribuam para a saúde, desempenho e felicidade dos animais.</p>
        </div>
        <img src="/assets/produtos.png" alt="Produtos Nobres Rações" />
        <article className="missionBox">
          <h6>Missão</h6>
          <h2>Nutrir e cuidar com amor.</h2>
        </article>
      </section>
      <Footer />
    </main>
  );
}

function CommitmentPage({ type }: { type: "compromissos" | "sustentabilidade" }) {
  const isSustainability = type === "sustentabilidade";
  return (
    <main>
      <Header />
      <PageHero title={isSustainability ? "Sustentabilidade" : "Compromissos"} subtitle="Conheça os pilares que guiam nossas ações diárias" />
      <section className="internalPage commitmentPage">
        <img src={isSustainability ? "/assets/bovinos.jpg" : "/assets/produtos.png"} alt="" />
        <div>
          <h2>{isSustainability ? "Sustentabilidade Ambiental" : "Nossos Compromissos"}</h2>
          <p>
            {isSustainability
              ? "Na Nobres Rações, entendemos que cada ação conta. Por isso buscamos práticas que beneficiem os animais e o planeta que todos compartilhamos."
              : "Nossos compromissos são alicerçados em valores e princípios que refletem dedicação à excelência e ao bem-estar animal."}
          </p>
          <p>
            {isSustainability
              ? "Nutrimos com respeito e cuidamos com responsabilidade, pensando em um legado positivo para as próximas gerações."
              : "Estamos comprometidos em superar expectativas, proporcionando produtos de alta qualidade e uma experiência baseada em integridade, transparência e responsabilidade."}
          </p>
        </div>
      </section>
      <CtaBand />
      <Footer />
    </main>
  );
}

function NewsPage() {
  return (
    <main>
      <Header />
      <PageHero title="Notícias" />
      <section className="internalPage newsPage">
        <h2>Últimas notícias:</h2>
        <div className="newsGrid">
          {posts.map((post) => (
            <a className="newsCard" href={post.href} key={post.href}>
              <img src={post.image} alt="" />
              <h3>{post.title}</h3>
              <span>{post.date}</span>
            </a>
          ))}
        </div>
        <h2>Mais antigas:</h2>
      </section>
      <CtaBand />
      <Footer />
    </main>
  );
}

function ContactPage() {
  return (
    <main>
      <Header />
      <PageHero title="Contato" subtitle="Nosso endereço e contato estão aqui." />
      <section className="internalPage contactPage">
        <div>
          <h6>CONTATO</h6>
          <h2>SAIBA ONDE ESTAMOS</h2>
          <p><strong>Fábrica</strong><br />Av. Pres. Getulio Vargas - Aeroporto Nobres - MT, 78470-000</p>
          <p><strong>E-mail</strong><br />nobresracoes@grupogns.com.br</p>
          <p><strong>Telefone</strong><br />+55 65 992267181</p>
        </div>
        <form onSubmit={(event) => submitByEmail(event, "Contato pelo site Nobres Racoes")}>
          <h2>Mande uma mensagem</h2>
          <p>Envie sua dúvida, questionamento ou sugestão.</p>
          <input name="nome" placeholder="Nome" required />
          <input name="empresa" placeholder="Empresa" />
          <input name="fone" placeholder="Fone" />
          <input name="email" type="email" placeholder="E-mail" required />
          <input name="assunto" placeholder="Assunto" />
          <textarea name="mensagem" placeholder="Menssagem" required />
          <button type="submit">Enviar mensagem</button>
        </form>
      </section>
      <Footer />
    </main>
  );
}

function ArticlePage({ post }: { post: typeof posts[number] }) {
  return (
    <main>
      <Header />
      <article className="articlePage">
        <h6>Nutrição</h6>
        <h1>{post.title}</h1>
        <time>{post.date}</time>
        <img src={post.image} alt="" />
        {post.body.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        <section className="commentBox">
          <h2>Deixe um comentário Cancelar resposta</h2>
          <textarea placeholder="Comentário" />
        </section>
        <aside className="catalogCta">
          <h5>Peça agora seu catálogo atualizado por e-mail</h5>
          <a className="button" href="/contato/">ORÇAMENTO</a>
        </aside>
      </article>
      <Footer />
    </main>
  );
}

function CtaBand() {
  return (
    <section className="ctaBand">
      <div>
        <h2>Transforme seu rebanho.</h2>
        <a href="/contato/" className="button">Faça uma cotação</a>
      </div>
    </section>
  );
}

function CatalogShowcase() {
  return (
    <>
      <section className="trustBand">
        <div>
          <p className="sectionLabel">Nossas rações</p>
          <h2>Nutrição com Confiança e Amizade</h2>
          <p>Descubra os principais benefícios que oferecemos aos nossos clientes.</p>
          <a href="/produtos/" className="button">Ver catálogo completo</a>
        </div>
        <img src="/assets/wp-original/todos-pacotes.png" alt="Catálogo de pacotes Nobres Rações" />
      </section>

      <section className="catalogGridSection">
        <div className="catalogGrid">
          {catalogItems.map(([title, text, image, href]) => (
            <a href={href} key={title}>
              <img src={image} alt={title} />
              <strong>{title}</strong>
              <p>{text}</p>
            </a>
          ))}
        </div>
      </section>
    </>
  );
}

function HomePage() {
  return (
    <main>
      <Header />

      <section className="hero">
        <div className="heroText">
          <h1>Nutrição Animal</h1>
          <p>É nossa força matriz, juntamente com transparência, honestidade e o compromisso com a satisfação do cliente.</p>
          <a href={catalogWhatsapp} target="_blank" rel="noreferrer" className="button">Receber o catálogo de rações</a>
        </div>
      </section>

      <section className="categoryCards">
        {categories.map(([title, text], index) => (
          <article className={index === 0 ? "active" : ""} key={title}>
            <span>{index === 0 ? "♞" : "♘"}</span>
            <h2>{title}</h2>
            <p>{text}</p>
          </article>
        ))}
      </section>

      <section className="production">
        <div className="productionCopy">
          <h2>Padrões Elevados de Higiene na Produção</h2>
          <p>Acreditamos que a qualidade começa nos detalhes. Nossa produção segue padrões elevados de higiene, assegurando que cada pacote de ração seja uma expressão de cuidado e dedicação.</p>
          <div className="specialList">
            <strong>Rações especiais para:</strong>
            {productLines.map((line) => <span key={line}>{line}</span>)}
          </div>
        </div>
        <img src="/assets/produtos.png" alt="Pacotes Nobres Nutrição Animal" />
      </section>

      <CtaBand />

      <CatalogShowcase />

      <section className="homeNews">
        <p className="sectionLabel">Conteúdo sobre Nutrição Animal</p>
        <h2>Conteúdo sobre Nutrição Animal</h2>
        <div className="newsGrid">
          {posts.map((post) => (
            <a className="newsCard" href={post.href} key={post.href}>
              <img src={post.image} alt="" />
              <h3>{post.title}</h3>
              <span>{post.date}</span>
            </a>
          ))}
        </div>
      </section>

      <Footer />
    </main>
  );
}

function App() {
  const path = window.location.pathname;
  const post = posts.find((item) => item.href === path);

  if (post) return <ArticlePage post={post} />;
  if (path.startsWith("/quem-somos")) return <AboutPage />;
  if (path.startsWith("/produtos")) return <ProductsPage />;
  if (path.startsWith("/compromissos")) return <CommitmentPage type="compromissos" />;
  if (path.startsWith("/sustentabilidade")) return <CommitmentPage type="sustentabilidade" />;
  if (path.startsWith("/noticias")) return <NewsPage />;
  if (path.startsWith("/contato")) return <ContactPage />;

  return <HomePage />;
}

export default App;
